export default __webpack_public_path__ + "static/media/play_video.143b888c.svg";